import type { Router } from 'vue-router';

export const globals = {} as {
    router: Router;
};
